/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z } from '../zod';

export const AuthenticationOauth2GoogleGet = {
  id: 'authentication.oauth2.google.get',
  tag: 'Authentication',
  summary: 'Login using Google over OAuth2',
  description: '',
  method: 'get',
  route: () => `/authentication/oauth2/google`,
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
